export const SERVICE_URL = '/connector';
export const STORE_ID = 47;
export const PROMOTION_ID = 2;
export const AFFILIATE_USERNAME = 'coupon@colpharma.com';
export const AFFILIATE_PASSWORD = 'Coupon2019';
export const RECAPTCHA_SITE_KEY = '6Ld5F2AbAAAAAIMQiockYOPZfe5mXryXto2-rKH0';
